// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"DndListPlaceholder_placeholder__sP9Cd"};